import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Column, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

const buttonCSS = css`
  position: fixed;
  z-index: 0;
  border: 0;
  border-radius: ${({ theme }) => theme.x6spacePx}px;
  width: ${({ theme }) => theme.x6spacePx}px;
  height: ${({ theme }) => theme.x6spacePx}px;
  text-decoration: none;
  vertical-align: top;
  bottom: ${({ theme }) =>
    `calc(${theme.x10spacePx}px + ${theme.safeAreaInsetBottom})`};
  right: ${({ theme }) => theme.x2spacePx}px;
`;

export const HackyHackyHitArea = styled('input')`
  ${buttonCSS}
  background: transparent;
`;

export const FloatingButton = styled('button')`
  ${buttonCSS}
  background: ${({ theme }) => theme.color.brand01};
  > svg {
    > * {
      fill: ${({ theme }) => theme.color.white};
    }
  }
`;

export const ResultWrapper = styled('div')`
  cursor: pointer;
`;

export const Count = styled(Column)`
  ${({ theme }) => theme.typography.tiny}
  opacity: 0.5;
  color: ${({ theme }) => theme.color.white};
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    padding-left: 0;
  `}
`;

export const Wrapper = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: ${({ theme }) => theme.x12spacePx}px;
  ${media.lgUp`
    fieldset {
      max-width: 260px;
    }
    margin-bottom: 350px;
  `}
`;
